import axiosInstance from "../services/AxiosInstance";

export function getUsersApi({ page, search, limit, roles = "" }) {
  return axiosInstance.get(
    `users?page=${page}&search=${search}&limit=${limit}&roles=${roles}`
  );
}

export function createUserApi(data) {
  return axiosInstance.post(`auth/register`, { ...data, dashboardreg: true });
}

export function updateUserApi(data, id) {
  return axiosInstance.put(`users/${id}`, data);
}

export function deleteUserApi(id) {
  return axiosInstance.delete(`users/${id}`);
}

export const sendPasswordEmailApi = (id) => {
  return axiosInstance.post(`users/${id}/send-password`); // adjust endpoint as per your backend
};

export const updatePasswordAndSendApi = (id, newPassword) => {
  return axiosInstance.put(`users/${id}/update-password`, {
    password: newPassword,
  });
};
